import dayjs from 'dayjs';
import { ApplicationTypeEnum } from '@legacy/shared-types/enums/application-type.enum';
import { BtlPropertyTypeEnum } from '@legacy/shared-types/enums/btl-property-type.enum';
import { IProductDTO } from '@legacy/shared-types/dto/product.type';
import { ProductTypeEnum } from '@legacy/shared-types/enums/product-type.enum';
import { parseBooleanish } from '@utils/general';
import { ICreateProductForm } from './types';

export const CreateProductDefaultValues: Partial<ICreateProductForm> = {
  productRange: null,
  productCategory: null,
  closeDate: null,
  description: undefined,
  equityShare: undefined,
  initialBaseRate: undefined,
  initialMargin: undefined,
  initialRate: undefined,
  launchDate: dayjs(new Date()),
  margin: undefined,
  maximumFTV: undefined,
  monthsInitial: undefined,
  productFees: undefined,
  productFeesPercentage: undefined,
  productTier: null,
  productType: null,
  salesforceId: undefined,
  isBrokerOnly: false,
  isVerified: false,
  isRestricted: false,
  isExpatriate: null,
  propertyCategory: null,
  maxFti: undefined,
};

export function formatProductForClone(product: IProductDTO): ICreateProductForm {
  return {
    productRange: product.productRange,
    productCategory: product.productCategory,
    closeDate: null,
    description: product.description,
    equityShare: Number(product.equityShare * 100).toFixed(2),
    initialBaseRate: Number(product.initialBaseRate * 100).toFixed(2),
    initialMargin: Number(product.initialMargin * 100).toFixed(2),
    initialRate: Number(((product.initialBaseRate + product.initialMargin) * 100).toFixed(5)),
    launchDate: null,
    margin: Number(product.margin * 100).toFixed(2),
    maximumFTV: Number(product.maximumFTV * 100).toFixed(2),
    monthsInitial: product.monthsInitial,
    productFees: product.productFees,
    productFeesPercentage: product.productFeesPercentage,
    productTier: product.productTier,
    productType: product.productType,
    salesforceId: '',
    isBrokerOnly: product.isBrokerOnly,
    isVerified: false,
    isRestricted: product.isRestricted,
    isExpatriate: parseBooleanish(product.metadata?.btlIsExpat),
    propertyCategory: (product.metadata?.btlPropertyType as BtlPropertyTypeEnum | undefined) ?? null,
    maxFti: product.maxFti,
  };
}

export const productFormValuesFormatter = (key: string, value: any) => {
  switch (key) {
    case 'salesforceId':
    case 'productTier':
    case 'monthsInitial':
    case 'productFees':
      return Number(value);
    case 'productType':
      return value as ProductTypeEnum;
    case 'applicationType':
      return value as ApplicationTypeEnum;
    case 'closeDate':
    case 'launchDate':
      return value?.toDate() || '';
    case 'equityShare':
    case 'initialBaseRate':
    case 'initialMargin':
    case 'margin':
    case 'maximumFTV':
      return Number(value) / 100;
    case 'maxFti':
      return Number(value);
    default:
      return value;
  }
};
